/**
 * Contenu par défaut si Strapi est vide ou indisponible (Markdown, comme l’éditeur Strapi).
 * À copier-coller dans l’admin Strapi (single type « Page Notre histoire »).
 */

export const NOTRE_HISTOIRE_DEFAULTS = {
  title: 'Notre Histoire',
  intro: `**TSAHAL CONNECTION** est une association fondée en 2015 par d'anciens soldats francophones avec pour objectif de donner les outils nécessaires aux futurs soldats afin que ceux-ci puissent effectuer un service de qualité dans Tsahal et ainsi s'intégrer de la meilleure des façons en Israël. Pour mener à bien ce projet, l'association a centralisé son cahier des charges sur deux axes principaux : les informations et l'accompagnement des futurs soldats.

D'une part il fallait créer une plate-forme en français avec toutes les informations essentielles pour les futurs soldats et d'autre part il fallait aussi donner la possibilité à ces candidats de recevoir un accompagnement de qualité, par des anciens soldats ayant eux-mêmes vécu ces expériences militaires.

Entre novembre 2015 et Mars 2019, ce sont près de 120 conférences qui ont été effectuées par l'association et pas moins de mille francophones qui ont pu recevoir un accompagnement individuel. Tsahal Connection était devenu une référence pour la communauté francophone que ce soit en Israël ou à l'étranger.

Cependant, entre Mars 2019 et juin 2019, l'accompagnement individuel ainsi que la plate-forme en ligne sont mis en pause pour des raisons politiques et financières.

En juillet 2019, l'association Tsahal Connection devient un projet de l'organisation Ach Gadol (grand frère en hébreu). Ses activités se sont élargies afin de permettre d'aider les jeunes francophones à s'engager dans les rangs de Tsahal.

Depuis le 1 juillet 2022, la structure du projet Tsahal Connection change complètement selon le modèle suivant:`,
  cardInfoConnection: `Conférences dans les programmes d'intégration/mairie/école ou séminaire des postes.

**Gratuit car subventionné par des donateurs.**`,
  cardSportConnection: `Activité sportive et simulation des classes militaires.

**Payant à tarif réduit car subventionné en partie par des donateurs.**`,
  cardExpertConnection: `Acompagnement individuel sur mesure pour les futurs soldats.

**Payant à plein tarif car non subventionné par des donateurs.**`,
  closing: `Le projet est dirigé depuis sa création en 2015 par Raphael Aaron Madar et comprend une quinzaine de volontaires.

Pour plus d'informations sur [Qualita](https://qualita.org.il/).

Pour plus d'informations sur [Ach Gadol](https://www.achgadol.org/fr/home-2/).`,
};
